/**
 * Read the shared company names once a colleague is signed in.
 *
 * ⚠️ NOT as the app starts. Until Oct 2026 the sign-in context asked for the read in an effect
 * that ran once, at start-up. On a fresh sign-in (a new browser, a signed-out tab, a preview
 * address) nobody is signed in at that moment: the database refuses the read, the cache was
 * marked "initialised" with nothing in it, and it stayed that way until the page was reloaded.
 * Pages hid it (each asks the function for the names it lacks). Settings did not: its panel
 * counted and listed the empty copy, and its re-check button said no names were held
 * (Lee, on a preview, 7 Oct 2026).
 *
 * Two things now hold, and each is enough on its own:
 *   · the read is asked for when there is a signed-in user (this hook), and again when the
 *     user changes;
 *   · a read that fails is not remembered as done (companyCache.initialize), so a read that is
 *     refused anyway (an account with no role yet, a sign-in the database has not seen yet)
 *     is tried again by the next page that needs a name.
 *
 * @param {string|null} uid  the signed-in user's id, or null when nobody is signed in
 */
import { useEffect } from "react";
import { companyCache } from "../services/companyCache";

export function useCompanyNamesLoad(uid) {
  useEffect(() => {
    if (!uid) return; // nobody signed in: the read would be refused
    companyCache.initialize().catch((error) => {
      console.warn("Company names could not be loaded:", error);
    });
  }, [uid]);
}
